import { styled } from '@mui/material/styles';

export const HiddenInput = styled('input')({
  position: 'absolute',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  opacity: 0,
  cursor: 'inherit',
  zIndex: 2,
});
